import './qicons.eot';
import './qicons.svg';
import './qicons.ttf';
import './qicons.woff';
import './qicons.woff2';
